/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Submittedsuccess1Inputs */

const en_questionnaire_submittedsuccess1 = /** @type {(inputs: Questionnaire_Submittedsuccess1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your questionnaire has been submitted successfully.`)
};

const fr_questionnaire_submittedsuccess1 = /** @type {(inputs: Questionnaire_Submittedsuccess1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre questionnaire a été soumis avec succès.`)
};

/**
* | output |
* | --- |
* | "Your questionnaire has been submitted successfully." |
*
* @param {Questionnaire_Submittedsuccess1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_submittedsuccess1 = /** @type {((inputs?: Questionnaire_Submittedsuccess1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Submittedsuccess1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_submittedsuccess1(inputs)
	return fr_questionnaire_submittedsuccess1(inputs)
});
export { questionnaire_submittedsuccess1 as "questionnaire_submittedSuccess" }